module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "logout-btn",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.doLogout()
      }
    }
  }, [_vm._v("ログアウト")]), _vm._v(" "), _c('div', {
    staticClass: "main-warp column"
  }, [_c('div', {
    staticClass: "title-box"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("マイページ")]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("ようこそ、" + _vm._s(_vm.nickname) + " 様")])]), _vm._v(" "), _c('div', {
    staticClass: "lists-box row"
  }, [_c('div', {
    staticClass: "lists-item column column-center",
    on: {
      "click": function($event) {
        return _vm.goPage('/room/index')
      }
    }
  }, [_c('el-badge', {
    staticClass: "item",
    attrs: {
      "value": _vm.record
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "icon column column-center row-center"
  }, [_c('el-image', {
    attrs: {
      "src": "https://online.engagement-card.com/img/icon1.png",
      "fit": "contain"
    }
  })], 1), _vm._v(" "), _c('div', [_vm._v("ルームに参加する")])], 1), _vm._v(" "), _c('div', {
    staticClass: "lists-item column column-center",
    on: {
      "click": function($event) {
        return _vm.goPage('/workspace')
      }
    }
  }, [_c('div', {
    staticClass: "icon column column-center row-center"
  }, [_c('el-image', {
    attrs: {
      "src": "https://online.engagement-card.com/img/icon2.png",
      "fit": "contain"
    }
  })], 1), _vm._v(" "), _c('div', [_vm._v("ルームを作成する")])])]), _vm._v(" "), _c('div', {
    staticClass: "lists-box row"
  }, [_c('div', {
    staticClass: "lists-item column column-center",
    on: {
      "click": _vm.toRecord
    }
  }, [(_vm.su != 1) ? _c('div', {
    staticClass: "ribbon"
  }, [_c('span', {
    staticClass: "ribbon2"
  }, [_vm._v("有料")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "icon column column-center row-center"
  }, [_c('el-image', {
    attrs: {
      "src": "https://online.engagement-card.com/img/icon3.png",
      "fit": "contain"
    }
  })], 1), _vm._v(" "), _c('div', [_vm._v("過去の結果を見る")])]), _vm._v(" "), _c('div', {
    staticClass: "lists-item column column-center",
    on: {
      "click": function($event) {
        return _vm.goPage('/info')
      }
    }
  }, [_c('div', {
    staticClass: "icon column column-center row-center"
  }, [_c('el-image', {
    attrs: {
      "src": "https://online.engagement-card.com/img/icon4.png",
      "fit": "contain"
    }
  })], 1), _vm._v(" "), _c('div', [_vm._v("アカウントを確認・変更")])])]), _vm._v(" "), (_vm.su == 0) ? _c('div', {
    staticClass: "des-box su",
    on: {
      "click": function($event) {
        return _vm.goPage('/pay/index')
      }
    }
  }, [_vm._v("有料プラン"), _c('br'), _vm._v("機能をアップグレードしませんか？")]) : _c('div', {
    staticClass: "des-box",
    on: {
      "click": function($event) {
        return _vm.goPage('/pay/choose')
      }
    }
  }, [_vm._v(" 料金プランを確認\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b1e9b724"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/index/My.vue
// module id = 898
// module chunks = 1